module.exports = __webpack_public_path__ + "img/beer_id-62.6e619c13.png";